import { useHasPermission } from "@dexteel/mesf-core";

// UI action names (must match SYSTEM.catActions). Granted per profile via
// SEC.UpsertProcedureAndSetToProfile. The three menu actions gate screen
// visibility; the edit action unlocks every write control.
export const PERMISSION_STRAIGHTENER_RECIPES = "ui.straightener.recipes";
export const PERMISSION_STRAIGHTENER_TREND = "ui.straightener.trend-display";
export const PERMISSION_STRAIGHTENER_LIMITS =
	"ui.straightener.parameter-limits";
export const PERMISSION_STRAIGHTENER_EDIT = "ui.straightener.edit";
export const PERMISSION_STRAIGHTENER_INFORMATION_RETRIEVAL =
	"ui.straightener.information-retrieval";

// True when the user may edit straightener recipes / limits (Supervisor). Read
// Only users lack the action, so every write control is hidden or disabled.
export const useStraightenerCanEdit = (): boolean => {
	const hasPermissionTo = useHasPermission();
	return hasPermissionTo(PERMISSION_STRAIGHTENER_EDIT);
};
